import { gsap } from "gsap";
import { ScrollSmoother } from "gsap/ScrollSmoother";

gsap.registerPlugin(ScrollSmoother);

/**
 * Scrolls to the specified target using GSAP's ScrollSmoother.
 * @see https://gsap.com/docs/v3/Plugins/ScrollSmoother/scrollTo()
 */
export default function gsapScrollTo(
    target,
    smooth = true,
    position = `top ${APP_HEADER_HEIGHT}`
) {
    const smoother = ScrollSmoother.get();

    // Validar que smoother existe
    if (!smoother) return;

    // Si no se pasa target, inicializamos los listeners para enlaces con anclas
    if (!target) {
        document.querySelectorAll('a[href^="#"]').forEach(anchor => {
            anchor.addEventListener('click', (e) => {
                const href = anchor.getAttribute('href');
                if (href && href !== '#' && href !== '#0') {
                    const targetEl = document.querySelector(href);
                    if (targetEl) {
                        e.preventDefault();
                        gsapScrollTo(href, smooth, position);
                    }
                }
            });
        });
        return;
    }

    // Validar que el target existe en el DOM para evitar el error de 'style' undefined
    const element = typeof target === "string" ? document.querySelector(target) : target;

    if (element) {
        smoother.scrollTo(target, smooth, position);
    } else {
        console.warn(`gsapScrollTo: El objetivo '${target}' no se encontró en el DOM.`);
    }
}
